import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TopNavigation from '../components/TopNavigation';
import LeftNavSidebar from '../components/LeftNavSidebar';
import RightWidgetsSidebar from '../components/RightWidgetsSidebar';
import ImageWithFallback from '../components/ImageWithFallback';
import MediaBox from '../components/MediaBox';
import PostMediaGallery, { hasMultiMedia } from '../components/PostMediaGallery';
import { renderTextWithLinks } from '../utils/text';
import { getProfileUrl } from '../utils/urls';
import { getPostById } from '../utils/secureFunctions';

interface PostData { id: string; userId: string; userName: string; username?: string | null; userPhoto: string; content: string; imageURL?: string; videoURL?: string; thumbnailURL?: string | null; media?: { url: string; type: 'image' | 'video' }[]; createdAt?: any; }

const PostPage: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const [post, setPost] = useState<PostData | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      if (!postId) return;
      try {
        const res = await getPostById(postId);
        setPost(res.post as any);
      } catch (e) {
        console.error('Failed to load post', e);
      }
    };
    load();
  }, [postId]);

  return (
    <div style={{ background: '#F5EDE1', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopNavigation />
      <LeftNavSidebar />
      <RightWidgetsSidebar />
      <div className="page-with-sidebars">
      <div className="page-inner">
        {!post ? (
          <div style={{ background: 'var(--color-surface)', borderRadius: 12, padding: 16, boxShadow: 'var(--shadow-sm)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <div className="skeleton skeleton-circle" style={{ width: 40, height: 40 }} />
              <div style={{ flex: 1 }}>
                <div className="skeleton skeleton-line" style={{ width: '30%', height: 12, marginBottom: 6 }} />
                <div className="skeleton skeleton-line" style={{ width: '50%', height: 10 }} />
              </div>
            </div>
            <div className="skeleton" style={{ width: '100%', height: 280, borderRadius: 10 }} />
          </div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <ImageWithFallback src={post.userPhoto} alt="" style={{ width: 40, height: 40, borderRadius: '50%' }} />
              <strong style={{ cursor: 'pointer' }} onClick={() => navigate(getProfileUrl({ id: post.userId, username: post.username }))}>{post.userName}</strong>
            </div>
            <div style={{ marginBottom: 8 }}>{renderTextWithLinks(post.content)}</div>
            {hasMultiMedia(post) ? (
              <PostMediaGallery media={post.media || []} poster={post.thumbnailURL} postId={post.id} />
            ) : (
              <>
                {post.imageURL && <MediaBox src={post.imageURL} type="image" />}
                {post.videoURL && <MediaBox src={post.videoURL} poster={post.thumbnailURL} type="video" controls contain />}
              </>
            )}
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default PostPage;
